import { Sections } from '../../components/Sections';

export const ArcSections = () => {
  return <Sections type={'LIFE'} />;
};
